<template>
  <div>
    <!-- 年度开工率 -->
    <Echart
      :options="options"
      id="bottomLeftChart"
      height="280px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data () {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        this.options = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.1)",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#7B7DDC"
              }
            }
          },
          title: {
            text: '维修业务统计',
            textStyle: {
              color: '#c3cbde'
            }
          },
          legend: {
            show: false,
            data: ["1", "2", "3"],
            textStyle: {
              color: "#B4B4B4",
              fontSize: '16'
            },
            top: "0",
            right: 0
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            data: newData.category,
            axisLine: {
              lineStyle: {
                color: "#B4B4B4"
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: [
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#B4B4B4"
                }
              },

              axisLabel: {
                formatter: "{value} "
              }
            },
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#B4B4B4"
                }
              },
              axisLabel: {
                formatter: "{value} "
              }
            },
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#B4B4B4"
                }
              },
              axisLabel: {
                formatter: "{value} "
              }
            }
          ],
          series: [
            {
              name: "1",
              type: "bar",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#952FD4" },
                    { offset: 1, color: "#EEA2E5" }
                  ])
                }
              },
              data: newData.lineData1
            },
            {
              name: "2",
              type: "bar",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "rgba(56,107,211,0.8)" },
                    { offset: 0.2, color: "rgba(56,147,211,0.5)" },
                    { offset: 1, color: "rgba(56,107,211,0.2)" }
                  ])
                }
              },
              z: -12,
              data: newData.lineData2
            },
            {
              name: "3",
              type: "bar",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "rgba(44,96,211,0.8)" },
                    { offset: 0.2, color: "rgba(44,96,211,0.5)" },
                    { offset: 1, color: "rgba(44,96,211,0.2)" }
                  ])
                }
              },
              z: -12,
              data: newData.lineData3
            }
          ]
        }
      },
      immediate: true,
      deep: true
    },
  },
}
</script>